import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import { EnhancedViewer as Viewer } from '@partsbadger/threedviewer';

import api from 'utils/api';

export const ThreeDViewer = observer(() => {
    const { quote_uuid, item_uuid } = useParams();

    const [url, setUrl] = useState();

    useEffect(() => {
        api.requests.get(`/customer/quote/${quote_uuid}/threed-signed-url/${item_uuid}`).then(data => {
            setUrl(data.url);
        });
    }, [quote_uuid]);

    if (url) {
        return (
            <div style={{ margin: 'auto', width: '90vw', height: '90vh' }}>
                <Viewer url={url} />
            </div>
        );
    }
    return <div />;
});
